<template>
  <div id="Shipping">
    <MyBanner :text="$t('banner.shippingPage')" />
    <MyHeaderPage :title="$t('shipping.title')" subtitle="" />
    <br /><br />
    <div v-if="!hasColocation && !viewLoader" style="margin: 20px 0; text-align: center; font-size: 18px; color: #001831;">
      {{ $t('noSolutionsServices.crossConnect') }}
    </div>
    <br /><br />
    <div class="typeShipping">
      <div class="card">
        <div class="cardContent">
          <h3>{{ $t('shipping.cardOne') }}</h3>
          <p class="text" v-html="$t('shipping.cardOneText')"></p>
          <div class="contentButton">
            <div
              class="cdlButton"
              id="takeShipping"
              :class="{ disabled: !hasColocation || viewLoader }"
              @click="hasColocation && !viewLoader && setShipping('ShippingDeliveries')"
              style="width: 87%;"
              :style="{ cursor: !hasColocation || viewLoader ? 'not-allowed' : 'pointer', opacity: !hasColocation || viewLoader ? 0.5 : 1 }"
            >
              {{ $t('shipping.deliveries') }}
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="cardContent">
          <h3>{{ $t('shipping.cardTwo') }}</h3>
          <p class="text">{{ $t('shipping.cardTwoText') }}</p>
          <div class="contentButton">
            <div
              class="cdlButton"
              id="takePickUp"
              :class="{ disabled: !hasColocation || viewLoader }"
              @click="hasColocation && !viewLoader && setShipping('ShippingPickUp')"
              style="width: 87%;"
              :style="{ cursor: !hasColocation || viewLoader ? 'not-allowed' : 'pointer', opacity: !hasColocation || viewLoader ? 0.5 : 1 }"
            >
              {{ $t('shipping.pickup') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import MyBanner from '@/components/MyBanner.vue'
import MyHeaderPage from '@/components/MyHeaderPage.vue'
import "@/assets/scss/Shipping.scss"

export default {
  name: 'MyShippingType',
  components: {
    MyBanner,
    MyHeaderPage,
  },
  data() {
    return {
      hasColocation: false,
      viewLoader: true,
    };
  },
  methods: {
    setShipping(type) {
      return this.$router.push({ name: type + this.$i18n.locale });
    },
    async checkColocationAssets() {
      try {
        const token = this.$keycloak.idToken;
        const baseUrl = window.VUE_APP_MISTRA_URL;

        const response = await this.axios.get(`${baseUrl}assets/v1/has-assets/colocation`, {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        this.hasColocation = response.data.hasAssets || false;
      } catch (error) {
        console.error("Error checking colocation assets:", error);
        this.hasColocation = false;
      } finally {
        this.viewLoader = false;
      }
    },
  },
  async mounted() {
    window.scrollTo(0, 0);
    await this.checkColocationAssets();
  }
}
</script>
